import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { getTeamLogo, getTeamName } from '../../../utils/SportsData';
import { Typography, Box } from '@mui/material';

const SuperPickemSubmitModal = ({ open, onClose, handleSubmitPick, submittedPickInfo, teams, league, schedule, success }) => {
    //console.log("Submit Pick Modal Info:", submittedPickInfo);

    const selectedGameId = submittedPickInfo?.gameId;
    const selectedTeamId = submittedPickInfo?.teamId;
    const selectedSpread = submittedPickInfo?.spread;
    const spreadForDisplay = selectedSpread === 0 ? 'Pk' : selectedSpread > 0 ? `+${selectedSpread}` : selectedSpread;
    const selectedGame = schedule?.find((game) => game.GlobalGameID === selectedGameId);
    const isHomeTeam = selectedGame?.GlobalHomeTeamID === selectedTeamId;
    const opponentId = selectedGame?.GlobalHomeTeamID === selectedTeamId ? selectedGame?.GlobalAwayTeamID : selectedGame?.GlobalHomeTeamID;
    //console.log("$$Selected Game:", selectedGame);

    const selectedTeamName = getTeamName(league, selectedTeamId, teams);
    const selectedTeamLogo = getTeamLogo(league, selectedTeamId, teams);
    const opponentTeamName = getTeamName(league, opponentId, teams);
    //console.log("$$Selected Team Name:", selectedTeamName, "Opponent Team Name:", opponentTeamName, "Selected Team Logo:", selectedTeamLogo, "Selected Spread:", selectedSpread);

  return (
    <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="super-pickem-submit-dialog-title"
        PaperProps={{
            sx: {
            width: '330px',
            maxWidth: '330px',
            }
        }}
    >
      <DialogTitle
        sx={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#002129',
            textAlign: 'center',
        }}
      >
        {success ? 'Pick Submitted!' : 'Submit Pick?'}
      </DialogTitle>
      
      <DialogContent>
        <Typography
            sx={{
                textAlign: 'center',
                color: '#002129',
                mb: 3,
                mt: 1,
            }}
        >
            <Box component="span" sx={{ fontWeight: 700 }}>
                {isHomeTeam ? selectedGame?.HomeTeam : selectedGame?.AwayTeam} ({spreadForDisplay})
            </Box>
            &nbsp;{isHomeTeam ? 'vs.' : '@'}&nbsp;
            {isHomeTeam ? selectedGame?.AwayTeam : selectedGame?.HomeTeam}
        </Typography>

        <Box>
            <img
                src={selectedTeamLogo}
                alt={selectedTeamName}
                style={{
                    width: '60px',
                    height: '60px',
                    margin: '0 auto',
                    display: 'block',
                }}
            />
        </Box>

        {!success && (
            <Typography
                sx={{
                    textAlign: 'center',
                    color: '#002129',
                    mb: 2,
                    mt: 3,
                }}
            >
                <Box component="span" sx={{ fontWeight: 700 }}>
                    {'Note: '}
                </Box>
                All picks are final and cannot be changed once submitted.
            </Typography>
        )}

        {success && (
            <Typography
                sx={{
                    textAlign: 'center',
                    color: '#002129',
                    mb: 2,
                    mt: 3,
                }}
            >
                Your pick has been submitted successfully!
            </Typography>
        )}


      </DialogContent>
      
      <DialogActions
        sx={{
            justifyContent: 'center',
            gap: '12px', // adds spacing between buttons
            pb: 2, // some bottom padding
        }}
        >
        {!success && (
            <>
                <Button
                    onClick={onClose}
                    sx={{
                        backgroundColor: '#f0f0f0',
                        color: '#002129',
                        fontWeight: 600,
                        fontSize: '14px',
                        '&:hover': {
                            backgroundColor: '#e0e0e0',
                        },
                    }}
                >
                    CANCEL
                </Button>

                <Button
                    onClick={handleSubmitPick}
                    color="primary"
                    variant="contained"
                >
                    SUBMIT
                </Button>
            </>
        )}
        {success && (
            <Button
                onClick={() => window.location.reload()}
                sx={{
                    backgroundColor: '#002129',
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: '14px',
                    '&:hover': {
                        backgroundColor: '#00161a',
                    },
                }}
            >
                CLOSE
            </Button>
        )}
        </DialogActions>

    </Dialog>
  );
};

export default SuperPickemSubmitModal;